<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>
Murder on the Cliffs</title><link href="css/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="css/page-template.xpgt" rel="stylesheet" type="application/adobe-page-template+xml"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<p class="tit">M<span class="smallcaps">URDER</span></p>
<p class="tit1"><em>on the</em></p>
<p class="tit2">C<span class="smallcaps">LIFFS</span></p>
<p class="stit"><span class="smallcaps">A DAPHNE du MAURIER MYSTERY</span></p>
<p class="au"><span class="smallcaps">JOANNA CHALLIS</span></p>
<p class="img1"><img alt="art" src="images/Art_logo.jpg"/></p>
<p class="pub"><span class="smallcaps">Minotaur Books</span>  <img alt="art" src="images/Art_tp.jpg"/>  <span class="smallcaps">New York</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?c7e4570e